<div tabindex="0">
  <app-preview-data-wrapper
    [label]="'Numer konta bankowego'"
    [data]="organization()?.numerRachunku! | bankAccountFormat"
    additionalCssClasses="font-bold"
  ></app-preview-data-wrapper>
</div>
